module.exports = __webpack_public_path__ + "img/embrionLogin.0d4e3377.png";